import { useMutation, useQueryClient } from "@tanstack/react-query";
import klydoApiClient from "../../../api/klydo";

const useSetUnlistedMutation = (klydoId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["set-unlisted", klydoId],
    mutationFn: ({
      unlisted,
      message,
    }: {
      unlisted: boolean;
      message?: string;
    }) => klydoApiClient.setUnlisted(klydoId, unlisted, message),
    onSettled: () => {
      // Unlisting rewrites `unlisted` and the review record together.
      queryClient.invalidateQueries({ queryKey: ["klydos"] });
      queryClient.refetchQueries({ queryKey: ["klydo", klydoId] });
    },
  });
};

export default useSetUnlistedMutation;
